import {
    SET_PROPERTY_TYPES_PRICE
} from './action-types';
import {getPrefix} from '../utils/urls';

export function setPropertyTypePrices(payload) {
    return {
        type: SET_PROPERTY_TYPES_PRICE,
        payload
    };
}

export function fetchPropertyTypePrices(lbsId, items) {
    return (dispatch) => {
        const tag = items.map((item) => `tags=${item.messageKey}`).join('&');

        const pathName = `/${getPrefix()}/api/property-type-prices?lbsId=${lbsId}&${tag}`;

        return fetch(pathName, {
            credentials: 'same-origin'
        }).then((res) => {
            if (!res.ok) {
                throw new Error(
                    'Failed loading destination insights'
                );
            }

            return res.json();
        }).then((payload) => {
            dispatch(setPropertyTypePrices(payload));
        }).catch((err) => console.log(err)); // eslint-disable-line no-console
    };
}
